// my own postal implementation

const hooks = {}; // each key holds an array of function handlers

const subscribe = (topic, name, handler) => {
    let handlers = hooks[topic];
    if ( ! handlers ) {
        handlers = [];
        hooks[topic] = handlers;
    }
    const h = handlers.find( h => h.name === name);
    if ( h ) {
        h.handler = handler;
    } else {
        const h = {topic: topic, name: name, "handler": handler};
        handlers.push ( h );
        console.log('subscribed handler, hooks = ' + JSON.stringify(hooks) + ' : ' + (typeof h.handler));
    }
}

const unsubscribe = (topic, name) => {
    let handlers = hooks[topic];
    if ( Array.isArray(handlers) ) {
        const h = handlers.findIndex( h => h.name === name);
        if ( h >= 0 ) {
            handlers.splice(h, 1);
        }
    }
};

const publish = (topic, payload) => {
    console.log('publish ' + topic);
    const handlers = hooks[topic];
    console.log('publish typeof handlers = ' + (typeof handlers));
    if ( Array.isArray(handlers) ) {
        handlers.forEach ( h => {
            console.log('publish to ' + h.name);
            if ( typeof h.handler === 'function') {
                h.handler(payload);
            }
        });
    }
};


export { subscribe,  unsubscribe, publish };